// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._18zrv77o{padding-inline:var(--ds-space-025,2px)}
._1bah1h6o{justify-content:center}
._1bsb1osq{width:100%}
._1e0c1txw{display:flex}
._1nmz1hna{word-break:break-word}
._1ul9gktf{min-width:20px}
._4t3igktf{height:20px}
._k48p1wq8{font-weight:var(--ds-font-weight-medium,500)}
._o5721jtm{white-space:pre-wrap}
._y3gn1e5h{text-align:left}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/rovo-agent-components/dist/esm/ui/agent-dropdown-menu/index.compiled.css"],"names":[],"mappings":"AAAA,WAAW,sCAAsC;AACjD,WAAW,sBAAsB;AACjC,WAAW,UAAU;AACrB,WAAW,YAAY;AACvB,WAAW,qBAAqB;AAChC,WAAW,cAAc;AACzB,WAAW,WAAW;AACtB,WAAW,4CAA4C;AACvD,WAAW,oBAAoB;AAC/B,WAAW,eAAe","sourcesContent":["._18zrv77o{padding-inline:var(--ds-space-025,2px)}\n._1bah1h6o{justify-content:center}\n._1bsb1osq{width:100%}\n._1e0c1txw{display:flex}\n._1nmz1hna{word-break:break-word}\n._1ul9gktf{min-width:20px}\n._4t3igktf{height:20px}\n._k48p1wq8{font-weight:var(--ds-font-weight-medium,500)}\n._o5721jtm{white-space:pre-wrap}\n._y3gn1e5h{text-align:left}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
